import styles from "./Card.module.css";
import { Heading } from "./Heading";

export const Card = ({
  imageUrl,
  imageWidth,
  imageHeight,
  imageAlt,
  title,
  titleLinkUrl,
  children,
}: {
  imageUrl: string;
  imageWidth: number;
  imageHeight: number;
  imageAlt: string;
  title: string;
  titleLinkUrl: string;
  children: string;
}) => (
  <div className={styles.card}>
    <img
      src={imageUrl}
      className={styles.cardImage}
      width={imageWidth}
      height={imageHeight}
      alt={imageAlt}
    />
    <div className={styles.cardContent}>
      <Heading level={3} className={styles.cardTitle}>
        <a href={titleLinkUrl} target="_blank" rel="noopener noreferrer">
          {title}
        </a>
      </Heading>
      {children}
    </div>
  </div>
);
